import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Stack,
} from '@mui/material';

type Props = {
  open: boolean;
  onClose: () => void;
};

export function PwaInstallDialog({ open, onClose }: Props) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Установить приложение</DialogTitle>
      <DialogContent>
        <Stack spacing={1.2}>
          <Typography variant="body2">На iPhone установка делается через Safari:</Typography>
          <Typography variant="body2">1) Открой сайт в Safari</Typography>
          <Typography variant="body2">2) Нажми “Поделиться” (квадратик со стрелкой)</Typography>
          <Typography variant="body2">3) Выбери “На экран «Домой»”</Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Понятно</Button>
      </DialogActions>
    </Dialog>
  );
}
